var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainLandingContainer" },
    [
      _c("div", { staticClass: "contentContainer" }, [
        _c("h1", { staticClass: "display-3 mainLandingHeadline" }, [
          _vm._v("KI-Readiness-Check")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "subheading" }, [
          _vm._v(
            "\n        Herzlich willkommen zu Ihrem KI-Readiness-Check! \n        "
          )
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttonWrapper" },
          [
            _c(
              "md-button",
              {
                staticClass: "md-raised mainCTA",
                attrs: { to: "/readinesscheck" }
              },
              [_vm._v("KI-Readiness-Check Starten")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "cta", attrs: { to: "/readinesscheck" } },
              [
                _c("span", { staticClass: "fancy-btn-text" }, [
                  _vm._v("KI-Readiness-Check Starten")
                ]),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "13px",
                      height: "10px",
                      viewBox: "0 0 13 10"
                    }
                  },
                  [
                    _c("path", { attrs: { d: "M1,5 L11,5" } }),
                    _vm._v(" "),
                    _c("polyline", { attrs: { points: "8 1 12 5 8 9" } })
                  ]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttonWrapper" },
          [
            _c(
              "md-button",
              {
                staticClass: "Secondary md-raised",
                attrs: { to: "/readinesscheck/res" }
              },
              [
                _c("span", { staticClass: "buttonText" }, [
                  _vm._v(" Früheres Ergebnis laden ")
                ])
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("vue-particles", {
        staticClass: "particles",
        attrs: {
          color: "#dedede",
          particleOpacity: 0.4,
          particlesNumber: 60,
          shapeType: "circle",
          particleSize: 4,
          linesColor: "#dedede",
          linesWidth: 1,
          lineLinked: true,
          lineOpacity: 0.4,
          linesDistance: 150,
          moveSpeed: 3,
          hoverEffect: false,
          hoverMode: "grab",
          clickEffect: true,
          clickMode: "push"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "textBlockBox" }, [
      _c("p", { staticClass: "textcontent" }, [
        _vm._v(
          "Dieser Check wurde speziell für KMU entwickelt, um die Bereitschaft \n          für die individuelle Entwicklung und Nutzung Künstlicher Intelligenz innerhalb eines Unternehmens \n          zu bewerten. Wir zeigen Ihnen, wo Ihr Unternehmen steht, wie weit Sie ihm Vergleich zu anderen \n          Unternehmen sind und welche nächsten Schritte helfen können, KI effektiv und nachhaltig in Ihrem \n          Unternehmen zu nutzen."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "textcontent" }, [
        _vm._v(
          "\n          Sie werden anhand von 40 Fragen zur KI-Readiness in den vier Dimensionen Technologie, \n          Organisation, Umwelt und Menschen durch den Check geführt.\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "textcontent" }, [
        _vm._v(
          "\n          Bitte beachten Sie: Einige Fragen im Check bilden einen Prozess ab, bei dem jede Stufe auf \n          der vorangegangenen aufbaut. In diesen Fällen bitten wir Sie, die Antwort vor dem ersten Bereich \n          auszuwählen, dessen Anforderung Ihr Unternehmen nicht mehr erfüllt. Dies ermöglicht uns, gezielt \n          auf Ihre aktuelle Position im Entwicklungsprozess einzugehen und passende Empfehlungen abzuleiten.\n        "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "textcontent" }, [_vm._v("Viel Erfolg!")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b310851c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b310851c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/landing/kircLanding.vue
// module id = null
// module chunks = 